import { MeasurerSystem } from '../typings/common';
import { GdClientMeasurerSystem, GdClientMeasurerSystemInput } from '../typings/graphql-grid';

export const mapMeasurerSystemFromApiToClient = (system: GdClientMeasurerSystem): MeasurerSystem => {
    switch (system) {
        case GdClientMeasurerSystem.MEDIASCOPE:
            return MeasurerSystem.MEDIASCOPE;

        default:
            throw new Error(`Measurer ${system} is not supported!`);
    }
};

export const mapMeasurerSystemFromClientToApi = (system: MeasurerSystem): GdClientMeasurerSystemInput => {
    switch (system) {
        case MeasurerSystem.MEDIASCOPE:
            return GdClientMeasurerSystemInput.MEDIASCOPE;

        default:
            throw new Error(`Measurer ${system} input is not supported`);
    }
};
